import React, { useEffect, useState } from 'react'

import { withStyles, Typography } from '@material-ui/core'
import styles from '../styles'
import { patchCourseCollectionAction } from 'src/reducers/collection/action'
import { PatchContent, PatchData } from 'src/model/patch'
import { useDispatch, useSelector } from 'react-redux'
import { CoreTextField } from 'src/components/core'
const AuthenticatedLinksViewContent = props => {
  const { classes } = props

  const [secretKey, setSecretKey] = useState(window.CONSTANTS.SECRET_KEY)

  useEffect(() => {
    setSecretKey(window.CONSTANTS.SECRET_KEY)
  }, [window.CONSTANTS])
  const entity = useSelector(state => state.collection.collection)
  const [collectionExternalId, setCollectionExternalId] = useState(
    entity?.externalId,
  )

  useEffect(() => {
    setCollectionExternalId(entity?.externalId)
  }, [entity])
  const dispatch = useDispatch()
  const userShop = window.CONSTANTS.SHOP_ID
  const patchCollection = () => {
    const patchSource = new PatchData(null, entity.id)
    patchSource.addContent(
      new PatchContent(
        collectionExternalId,
        'externalId',
        PatchData.OPERATION_REPLACE,
      ),
    )

    dispatch(patchCourseCollectionAction(patchSource, () => {}))
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 16,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 4,
          }}
        >
          <Typography fontSize={'15px'} fontWeight={400} color={'#002E47'}>
            External ID
          </Typography>
          <Typography fontSize={'14px'} fontWeight={400} color={'#919EAB'}>
            (Optional)
          </Typography>
        </div>
        <div
          style={{
            width: '50%',
          }}
        >
          <CoreTextField
            label="Enter External ID"
            value={collectionExternalId}
            onChange={e => setCollectionExternalId(e.target.value)}
            onBlur={() => patchCollection()}
            fullWidth={true}
          />
        </div>
      </div>
      <Typography fontSize={'15px'} fontWeight={500}>
        Prerequisites
      </Typography>
      <div>
        <ul className={classes.liPadding}>
          <li>
            <Typography fontSize={'14px'} fontWeight={400}>
              You’ve chosen the right magic link depending on the content type.
              For more details, refer to the{' '}
              <a
                target="_blank"
                href="https://intercom.help/mini-course-generator/en/articles/9403804-enable-access-with-in-app-authentication"
              >
                {' '}
                Enable access with in-app authentication{' '}
              </a>{' '}
              topic in the help center.
            </Typography>
          </li>

          <li>
            <Typography fontSize={'14px'} fontWeight={400}>
              You have a list of unique user identifiers.
            </Typography>
          </li>
        </ul>
      </div>
      <div
        style={{
          padding: '12px 16px',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          backgroundColor: '#E3F3FF',
        }}
      >
        <Typography
          fontSize={'14px'}
          fontWeight={400}
          dangerouslySetInnerHTML={{
            //__html: `import crypto from 'crypto'; <br/> const generateSignature = (url, secret) => {<br/>&nbsp;&nbsp;return crypto<br/>&nbsp;&nbsp;&nbsp;&nbsp;.createHmac('sha256', secret)<br/> &nbsp;&nbsp;&nbsp;&nbsp;.update(url)<br/>&nbsp;&nbsp;&nbsp;&nbsp;.digest('hex');<br/>}<br/>const SHARED_SECRET = "${secretKey}";<br/>const signature = generateSignature(url, SHARED_SECRET);<br/>// signature = SIGNATURE_SAMPLE_RESULT`,
            __html: `var CryptoJS = require("crypto-js");
            <br/>var collectionId = "${entity?.id}";
            <br/>var secretKey = CryptoJS.enc.Utf8.parse("${secretKey}");
            <br/>var courseCode = "YOUR_COURSE_CODE"; // Optional
            <br/>var host = "YOUR_CUSTOM_DOMAIN"; // Optional
            
            <br/><br/>function encryptData(data) {
              <br/>&ensp; let encryptedBytes = CryptoJS.AES.encrypt(
                <br/>&emsp;CryptoJS.enc.Utf8.parse(JSON.stringify(data)),
                <br/>&emsp;secretKey,
                <br/>&emsp;{ mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 },
                <br/>&ensp; );
                <br/>&emsp;return encodeURIComponent(encryptedBytes.toString());
                <br/>}
                <br/><br/>let data = {
                  <br/>&emsp;//courseCollectionId: collectionId, //Optional
                  <br/>&emsp;//courseCode: courseCode, //Optional
                  <br/>&emsp;//externalIds: ["Your external Id 1", "Your external Id 2"], // Optional (Array)
                  <br/>&emsp;//host: host, // Optional
                  <br/>&emsp;//name: "You can set name surname", // Optional
                  <br/>&emsp;//email: "You can set email", // Optional
                  <br/>&emsp;username: "You have to set username",
                  <br/>};
            
                  <br/><br/>var token = encryptData(data);
                  <br/>console.log(
              "https://gateway.minicoursegenerator.com/api/learner-auth/${userShop}/generate-magic-link?token=&#36;{token}",
            );
            <br/>// You can redirect or open inside iframe to this url
            `,
          }}
        ></Typography>
      </div>
      {/*<div>
        <Typography fontSize={'15px'} fontWeight={500}>
          Related Links
        </Typography>
        <ul className={classes.liPadding}>
          {linkContent.map((item, index) => (
            <li key={index}>
              <a
                href={item.link}
                style={{ fontSize: '14px', fontWeight: 400 }}
                target="blank"
              >
                {item.title}
              </a>
            </li>
          ))}
        </ul>
          </div>*/}
    </div>
  )
}

export default withStyles(styles)(AuthenticatedLinksViewContent)
